export const Panel = ({ className = "", children, ...rest }) => (
  <div className={`rounded-2xl border border-cc-border bg-cc-panel ${className}`} {...rest}>
    {children}
  </div>
);

export const SectionLabel = ({ children, right }) => (
  <div className="flex items-center justify-between mb-4">
    <p className="font-body text-[11px] font-bold uppercase tracking-[0.18em] text-cc-faint">{children}</p>
    {right}
  </div>
);

export const StatCard = ({ label, value, sub, subTone = "sub", icon: Icon, testid }) => {
  const toneCls =
    subTone === "pos" ? "text-cc-pos" : subTone === "hot" ? "text-cc-hot" : subTone === "warn" ? "text-cc-warn" : subTone === "accent" ? "text-cc-accent" : "text-cc-faint";
  return (
    <Panel data-testid={testid} className="p-5 hover:border-cc-accent/50 transition-colors">
      <div className="flex items-start justify-between">
        <p className="font-body text-[11px] font-bold uppercase tracking-[0.16em] text-cc-faint">{label}</p>
        {Icon && (
          <span className="inline-flex items-center justify-center w-9 h-9 rounded-xl bg-cc-accent/10 text-cc-accent">
            <Icon className="w-4 h-4" />
          </span>
        )}
      </div>
      <p className="mt-3 font-heading font-extrabold text-3xl text-cc-ink tracking-tight">{value}</p>
      {sub && <p className={`mt-1 font-body text-xs font-medium ${toneCls}`}>{sub}</p>}
    </Panel>
  );
};

export const BarRow = ({ label, value, max, suffix = "", tone = "accent" }) => {
  const pct = max > 0 ? Math.round((value / max) * 100) : 0;
  const barCls = tone === "pos" ? "bg-cc-pos" : tone === "hot" ? "bg-cc-hot" : tone === "warn" ? "bg-cc-warn" : "bg-cc-accent";
  return (
    <div className="flex items-center gap-3 py-1.5">
      <span className="w-36 shrink-0 font-body text-sm text-cc-sub truncate">{label}</span>
      <div className="flex-1 h-2.5 rounded-full bg-cc-panel2 overflow-hidden">
        <div className={`h-full rounded-full ${barCls} transition-all duration-500`} style={{ width: `${pct}%` }} />
      </div>
      <span className="w-14 text-right font-body text-sm font-bold text-cc-ink">{value}{suffix}</span>
    </div>
  );
};

export const MonthBars = ({ data }) => {
  const max = Math.max(1, ...data.map((d) => d.value));
  return (
    <div className="flex items-end gap-2 h-48">
      {data.map((d, i) => (
        <div key={i} className="flex-1 h-full flex flex-col items-center gap-2 group">
          <div className="w-full flex items-end justify-center flex-1">
            <div
              className="w-full max-w-[36px] rounded-t-md bg-gradient-to-t from-cc-accent/30 to-cc-accent group-hover:from-cc-pos/40 group-hover:to-cc-pos transition-all duration-300"
              style={{ height: `${Math.max((d.value / max) * 100, d.value > 0 ? 6 : 2)}%` }}
              title={`${d.label}: ${d.value}`}
            />
          </div>
          <span className="font-body text-[10px] text-cc-faint">{d.label}</span>
        </div>
      ))}
    </div>
  );
};

export const inputCls =
  "w-full rounded-xl border border-cc-border bg-cc-panel2 px-4 py-2.5 font-body text-sm text-cc-ink placeholder:text-cc-faint focus:outline-none focus:ring-2 focus:ring-cc-accent/40 focus:border-cc-accent transition";
